export default "/images/49383c46ac0f0d7ea118fba6c1cda34c.avif";